import { sendCustomTrack } from 'common/js/TrackAnalyticsHelper';
import { FormatContext, ILoadingStrategy } from './loading-strategy-factory';

export class UnloadEmptyTagLoadingStrategy implements ILoadingStrategy {
  isRunnable(formatContext: any): boolean {
    return formatContext.context.creativeSource === 'redirect';
  }

  alterConfiguration(formatContext: FormatContext): FormatContext {
    return formatContext;
  }

  onAfterRender(formatContext: FormatContext): void {}

  onBeforeRender(formatContext: FormatContext): void {
    if (!formatContext.config?.tag) {
      sendCustomTrack('empty_tag');
      throw Error('Empty tag received');
    }
  }

  onResize(formatContext: FormatContext): void {}
}
